import { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'

import { MetricDeltaTone } from '../components/cockpitMetricCell/CockpitMetricCell'

/** A metric with nothing behind it: the cockpit's `--` cells. `0` counts as empty in this feature —
 *  the hierarchy table shows `--` for it and hides the rows made entirely of it — even though the
 *  data layer deliberately keeps a real `0` distinct from missing data (see `sumMeasure`). */
export const isEmptyMetricValue = (value: number | null) =>
  value === null || value === 0 || !Number.isFinite(value)

/** Growth-badge color for a delta value — green above baseline, red below, gray at/unknown. */
export const getDeltaTone = (value: number | null): MetricDeltaTone => {
  if (value === null || value === 0) {
    return 'neutral'
  }

  return value > 0 ? 'positive' : 'negative'
}

/** `{fy}` replace-param for translation strings, as the 2-digit fiscal year, e.g. `26`. */
export const getYearParams = (fYear: number): TReplaceOptions[] => {
  const fYearLabel = String(fYear).slice(-2)
  return [{ key: '{fy}', value: fYearLabel }]
}
